import React from 'react';
import styles from './enrichment-associated-cert.module.sass';
import { Button, Typography, Tooltip } from 'antd';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';

function EnrchmentAssociatedCert({
  history,
  oldData,
  status,
  parsedData,
  props,
}) {
  const { Title, Text } = Typography;
  const name = oldData?.ioc_name;

  if (status === 'loaded') {
    return (
      <div className={styles.enrichment_associated_cert}>
        <div className={styles.title}>
          <Title level={4}>Associated Certificates</Title>
          <Text>Get certificate data collected from IPv4 scanning</Text>
        </div>

        <div className={styles.cert_container}>
          <div className={styles.cer_row}>
            <Text className={styles.ip}>{name ? name : '-'}</Text>
            {props?.mySubscriptionPlan?.has_access_to_query_builder ? (
              <Link
                to={
                  `/explore/query-builder?query=cf2c717a-ebd4-44be-87ab-5028a52dd78d&ipv4=${parsedData?.result}&backLink=` +
                  encodeURIComponent(window.location.pathname) +
                  encodeURIComponent(window.location.search)
                }
              >
                <Button
                  disabled={
                    !props?.mySubscriptionPlan?.has_access_to_query_builder
                  }
                  type="primary"
                >
                  Search
                </Button>
              </Link>
            ) : (
              <Tooltip
                title={
                  props?.mySubscriptionPlan?.has_access_to_query_builder ? (
                    ''
                  ) : (
                    <>
                      This option is not part of this subscription plan. To
                      upgrade your subscription contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
              >
                <Button
                  disabled={
                    !props?.mySubscriptionPlan?.has_access_to_query_builder
                  }
                  type="primary"
                >
                  Search
                </Button>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={styles.enrichment_associated_cert}>
        <div className={styles.title}>
          <Title level={4}>Associated Certificates</Title>
          <Text>Get certificate data collected from IPv4 scanning</Text>
        </div>

        <div className={styles.cert_container}>
          <div className={cx({ [styles['loading']]: !name }, styles.cer_row)}>
            <LoadingSkeleton />
          </div>
        </div>
      </div>
    );
  }
}

export default EnrchmentAssociatedCert;
